// extracted by mini-css-extract-plugin
module.exports = {"root":"Terminal_root__2u8aI","terminal_cont":"Terminal_terminal_cont__1_jdW"};